import { shouldAnimateScroll } from './dom-utils';

type ScrollResetListener = () => void;

const listeners = new Set<ScrollResetListener>();

/**
 * Announces that a list scrolled the viewport back to its top. Unaddressed, since
 * announcer and table are siblings; safe while a page has one such list.
 */
export function notifyScrollReset() {
  // Copied so a subscriber unsubscribing on notify cannot mutate mid-iteration.
  [...listeners].forEach(listener => listener());
}

/**
 * Subscribes to reset announcements, returning the unsubscribe.
 */
export function subscribeToScrollReset(listener: ScrollResetListener) {
  listeners.add(listener);

  return () => {
    listeners.delete(listener);
  };
}

/**
 * Scrolls `element` to the start of the viewport, animating only a short trip,
 * then announces the reset. Does nothing without an element.
 */
export function resetScrollToTop(element: HTMLElement | null) {
  if (!element) return;

  // Ignores the target's `scroll-margin-top`, so it errs toward jumping.
  const distance = Math.abs(element.getBoundingClientRect().top);

  element.scrollIntoView({
    behavior: shouldAnimateScroll(distance) ? 'smooth' : 'instant',
    block: 'start',
  });

  notifyScrollReset();
}
